// extracted by mini-css-extract-plugin
module.exports = {"full_screen_msg":"Loding_full_screen_msg__2Ca4g","fullPage":"Loding_fullPage__23ZRp"};